import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {  IconDefinition, faLaptopMedical } from '@fortawesome/free-solid-svg-icons';
import './styles.css'
import { TabsProps } from '../../interfaces/props/TabsProps';
import { TypeNotificationEnum } from '../../interfaces/enum/TypeNotificationEnum';
import { faFolder } from '@fortawesome/free-regular-svg-icons';
import { faBullhorn, faNewspaper } from '@fortawesome/pro-regular-svg-icons';
import { useAccessibility } from '../../Store/contexts/AccessibilityContext';

function Tabs(props: TabsProps) {
    const [position, setPosition] = useState<string>(TypeNotificationEnum.Notificacoes);
    const accessibility = useAccessibility();

    useEffect(() => {
        if(props.tab !== ''){
            setPosition(props.tab)
        }
    }, [props.tab])

    const handleClick = (param: string) => {
        setPosition(param);
        props.handleTab(param);
    };

    return (
        <div className="tabs-holder">
            <div className="tabs">
                <button style={accessibility.textStyleAccessibility} onClick={() => handleClick(TypeNotificationEnum.Notificacoes)} className={`tab ${position === TypeNotificationEnum.Notificacoes && 'selected-tab'} ${accessibility.contrastMode && 'accessibility-color'}`}>
                    <FontAwesomeIcon icon={faFolder} />&nbsp; Todos
                </button>
                <button style={accessibility.textStyleAccessibility} onClick={() => handleClick(TypeNotificationEnum.Comunicados)} className={`tab ${position === TypeNotificationEnum.Comunicados && 'selected-tab'} ${accessibility.contrastMode && 'accessibility-color'}`}>
                    <FontAwesomeIcon flip='horizontal' icon={faBullhorn as IconDefinition} />&nbsp;Comunicados
                </button>
                <button style={accessibility.textStyleAccessibility} onClick={() => handleClick(TypeNotificationEnum.SaudeOnline)} className={`tab ${position === TypeNotificationEnum.SaudeOnline && 'selected-tab'} ${accessibility.contrastMode && 'accessibility-color'}`}>
                    <FontAwesomeIcon icon={faLaptopMedical} />&nbsp;Saúde
                </button>
                <button style={accessibility.textStyleAccessibility} onClick={() => handleClick(TypeNotificationEnum.PesquisaSatisfacao)} className={`tab ${position === TypeNotificationEnum.PesquisaSatisfacao && 'selected-tab'} ${accessibility.contrastMode && 'accessibility-color'}`}>
                    <FontAwesomeIcon icon={faNewspaper} />&nbsp;Pesquisa
                </button>
            </div>
            <div className="slider">
                {position === TypeNotificationEnum.Notificacoes && <div className={`indicator indicator-0 ${accessibility.contrastMode && 'accessibility-color'}`} />}
                {position === TypeNotificationEnum.Comunicados && <div className={`indicator indicator-1 ${accessibility.contrastMode && 'accessibility-color'}`} />}
                {position === TypeNotificationEnum.SaudeOnline && <div className={`indicator indicator-2 ${accessibility.contrastMode && 'accessibility-color'}`} />}
                {position === TypeNotificationEnum.PesquisaSatisfacao && <div className={`indicator indicator-3 ${accessibility.contrastMode && 'accessibility-color'}`} />}
            </div>
        </div>
    );
};

export default Tabs;